<template>
  <div class="content-slider-500"
       :class="[sliderGridStatus ? 'content-slider-500-grid' : 'content-slider-500-without-grid']">

    <div class="row content-slider-500-header-section ">
      <div class="col-6" data-slot="p-1">

      </div>
      <div class="col-6 text-left">
        <m-a :href="{name:'Posts',query:{...setSliderQuery()}}">
          <span v-t="`content.slider.more`"></span>
          <i class="bi bi-arrow-left mr-1"></i>
        </m-a>
      </div>
    </div>

    <m-content-wrapper :content-type="contentType" :wait-for-category="waitForCategoryProp"
                       :category-column="categoryColumnProp"
                       :content-category="contentCategory">
      <template v-slot="{contents}">
        <swiper v-bind="swiperOptions" :navigation="true" :modules="modules"
                :class="[sliderGridStatus ? 'content-slider-500-grid py-3' : 'py-3']"
                @slideChange="onSlideChange"
                @swiper="onSlideChange"
                ref="swiperRef">
          <swiper-slide class=""
                        :class="[
                            sliderGridStatus ? 'content-slider-500-swiper-slider-grid' : 'content-slider-500-swiper-slider',
                            {
                              'swiper-middle-active-item': index === middleCardIndex,
                              'next-slide': index === nextSlide,
                              'prev-slide': index === prevSlide
                            }
                          ]"
                        v-for="(content,index) in contents"
                        :key="content.id">
            <m-a v-if="cardLink" :href="setCardLink(content)">
              <component :is="contentCard" :content="content"/>
            </m-a>
            <component v-else :is="contentCard" :content="content"/>
          </swiper-slide>
        </swiper>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {ContentArchiveProps} from '../Archive/ContentArchiveProps'
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mA from '../../Tags/A'
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import 'swiper/css/grid';

import {Navigation, Grid, Pagination} from "swiper";
import {Cards} from "../Card/Cards";

export default {
  name: "ContentSlider500",
  components: {...Cards, mContentWrapper, mA, Swiper, SwiperSlide},
  props: {
    ...ContentArchiveProps,
    contentDirectLinkOn: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      modules: [Navigation, Grid, Pagination],
    };
  },
  data() {
    return {
      swiperOptions: {
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          400: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          430: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          490: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          520: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          980: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 0,

          },
        },
        loop: false,
      },
      middleCardIndex: 0,
      nextSlide: 0,
      prevSlide: 0,
    }
  },
  methods: {
    setSliderQuery() {
      if (this.contentCategory == null) {
        return {}
      }
      return {category: this.contentCategory.join(','), category_column: 'slug'}
    },
    setCardLink(content) {
      if (this.cardLink) {


        if (this.contentDirectLinkOn) {
          return this.findLinkOnContent(content.abstraction)
        }

        if (this.contentType == 'post') {
          return {name: 'SinglePost', params: {slug: content.slug}}
        } else {
          return {name: 'SinglePage', params: {slug: content.slug}}
        }


      }
      return 'javascript:void(0)'
    },
    onSlideChange(swiper) {
      // Get the active index
      const activeIndex = swiper.activeIndex;

      // Calculate the middle index based on the number of slides per view
      const slidesPerView = swiper.params.slidesPerView;


      this.middleCardIndex = activeIndex + Math.floor(slidesPerView / 2);
      this.nextSlide = this.middleCardIndex + 1;
      this.prevSlide = this.middleCardIndex - 1;

    },
  },
  beforeMount() {

    /* swiper break points  */
    this.swiperOptions.breakpoints["300"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["400"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

    /* swiper space between */
    this.swiperOptions.breakpoints["300"].spaceBetween = 0
    this.swiperOptions.breakpoints["400"].spaceBetween = 0
    this.swiperOptions.breakpoints["430"].spaceBetween = 0
    this.swiperOptions.breakpoints["490"].spaceBetween = 0

    this.swiperOptions.breakpoints["520"].spaceBetween = 0
    this.swiperOptions.breakpoints["768"].spaceBetween = 0

    this.swiperOptions.breakpoints["980"].spaceBetween = 0
    this.swiperOptions.breakpoints["1200"].spaceBetween = 0


    if (this.sliderGridStatus) {
      this.swiperOptions['grid'] = {rows: this.sliderGridRows,}
    }
    this.swiperOptions.loop = this.sliderLoop
  }
}
</script>

<style scoped>
.content-slider-500-without-grid :deep(.swiper-wrapper) {
  padding: 30px 0;
}

.content-slider-500-grid {
  height: 600px;
}

.content-slider-500-swiper-slider-grid {
  height: calc((100% - 50px) / 2) !important;
}

.swiper-slide:not(.swiper-middle-active-item) {
  filter: blur(1px);

}

.content-slider-500 .swiper-middle-active-item {
  z-index: 10;
  scale: 1.15
}

.content-slider-500 .next-slide {
  filter: blur(0.5px);
  z-index: 9;
  scale: 1.05
}

.content-slider-500 .prev-slide {
  filter: blur(0.5px);
  z-index: 9;
  scale: 1.05;
}


</style>